import React, { useState, useEffect } from "react";
import { Grid, Card, Skeleton, Tooltip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { fetchThroughputData } from "../../../../api/overView";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

const UserThroughputCard = () => {
  const { storeId } = useParams(); 
  const [throughputData, setThroughputData] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedDate = useSelector((state) => state.customization.selectedDate);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchThroughputData(
          selectedDate || new Date(),
          storeId,
          abortController.signal
        );

        console.log("response fetchThroughputData", response);

        if (!abortController.signal.aborted) {
          setThroughputData(response.data?.data?.throughputData || []);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error fetching throughput data:", error);
          setThroughputData([]);
        }
      } finally {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line
  }, [selectedDate]);

  return (
    <Grid item xs={12} sm={12} md={2.4} lg={2.4} xl={2.4}>
      <Card
        className="border relative border-gray-300"
        sx={{
          height: "276px",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px"
        }}
      >
        <div className="flex w-full flex-col gap-1 p-3">
          {/* Header */}
          <div className="flex items-center gap-2">
            <PersonIcon className="bg-blue-500 text-white rounded-full p-2 text-6xl" />
            <div style={{ width: loading ? "120px" : "auto" }}>
              {loading ? (
                <>
                  <Skeleton variant="text" width="100%" height={40} />
                  <Skeleton variant="text" width="80%" height={28} />
                </>
              ) : (
                <>
                  <p className="text-3xl">{throughputData.length}</p>
                  <p className="text-lg font-semibold">Users Tracked</p>
                </>
              )}
            </div>
          </div>

          {/* List Container */}
          <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
            <div className="text-xs text-gray-500 mb-2 italic">Throughput Details</div>
            {loading ? (
              [...Array(3)].map((_, index) => (
                <div key={index} className="mb-2">
                  <div className="bg-white rounded p-2 text-sm shadow-sm">
                    <div className="flex items-start gap-2">
                      <Skeleton variant="circular" width={12} height={12} sx={{ marginTop: "4px" }} />
                      <div className="flex-1">
                        <Skeleton variant="text" width="60%" height={24} />
                        <Skeleton variant="text" width="40%" height={20} />
                        <Skeleton variant="text" width="30%" height={20} />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : throughputData.length === 0 ? (
              <div className="text-sm text-gray-500 text-center py-4">No users found</div>
            ) : (
              throughputData.map((user, index) => <UserCardItem key={index} user={user} />)
            )}
          </div>
        </div>
      </Card>
    </Grid>
  );
};

const UserCardItem = ({ user }) => (
  <Tooltip
    title={
      <div style={{ textAlign: "left", fontSize: "12px", padding: "4px" }}>
        <p><strong>📞 Phone:</strong> {user.number}</p>
        <p><strong>📧 Email:</strong> {user.email}</p>
      </div>
    }
    arrow
    placement="top"
  >
    <div className="bg-white rounded p-2 mb-2 text-sm shadow-sm cursor-pointer transition duration-200 hover:bg-gray-100">
      <div className="flex items-start gap-2">
        <PersonIcon sx={{ color: "#3b82f6", fontSize: "12px", marginTop: "4px" }} />
        <div>
          <div className="font-bold">{user.user_name}</div>
          <div className="text-xs text-gray-500">{user.role}</div>
          <div className="text-xs text-gray-500">
            Throughput: {user.total_batch_scan + user.total_ean}
          </div>
        </div>
      </div>
    </div>
  </Tooltip>
);

export default UserThroughputCard;
